import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "col q-pb-sm" }
const _hoisted_3 = { class: "col q-pb-sm" }
const _hoisted_4 = { class: "col q-pb-sm" }
const _hoisted_5 = {
  key: 0,
  class: "col q-pb-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "col q-pb-sm"
}
const _hoisted_7 = { class: "col q-pb-sm" }
const _hoisted_8 = { class: "col q-pb-sm" }
const _hoisted_9 = { class: "col q-pb-sm" }
const _hoisted_10 = { class: "col q-pb-sm" }
const _hoisted_11 = { class: "col q-pb-sm" }
const _hoisted_12 = { class: "col q-pb-sm" }
const _hoisted_13 = { class: "row items-center q-gutter-sm q-mb-sm" }
const _hoisted_14 = { class: "row items-center q-gutter-xs q-mb-sm" }
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "col q-pb-sm" }
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "col q-pb-sm" }
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "col q-pb-sm" }
const _hoisted_21 = { class: "col q-pb-sm" }
const _hoisted_22 = { class: "col q-pb-sm" }
const _hoisted_23 = { class: "col q-pb-sm" }
const _hoisted_24 = { class: "col q-pb-sm" }
const _hoisted_25 = {
  key: 0,
  class: "col q-pb-sm"
}
const _hoisted_26 = { class: "row items-start q-gutter-sm" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = { class: "col q-pb-sm" }
const _hoisted_31 = { class: "col q-pb-sm" }
const _hoisted_32 = { class: "col q-pb-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_PigRunSummary = _resolveComponent("PigRunSummary")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_BackwardsConfirmDialog = _resolveComponent("BackwardsConfirmDialog")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_PigRunWizard = _resolveComponent("PigRunWizard")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!
  const _component_PipelineSectionManager = _resolveComponent("PipelineSectionManager")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                _createTextVNode("Pig Run Manager", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onCancelPigRun
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_btn, {
                flat: "",
                rounded: "",
                class: "btn-brand",
                icon: "fas fa-plus",
                label: "New Pig Run",
                "no-caps": "",
                onClick: _ctx.onNewPigRun
              }, null, 8, ["onClick"]),
              _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_q_separator, { inset: "" }),
              _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
              (_ctx.pigRunOptions.length > 0)
                ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                    key: 0,
                    modelValue: _ctx.pigRunSectionExpanded,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pigRunSectionExpanded) = $event)),
                    dense: "",
                    "header-class": "text-overline text-grey-brand",
                    label: "Pig Runs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedPigRun,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPigRun) = $event)),
                          _ctx.onPreviewPigRun
                        ],
                        dense: "",
                        color: "blue-brand",
                        outlined: "",
                        clearable: "",
                        "use-input": !_ctx.selectedPigRun,
                        "input-debounce": "300",
                        options: _ctx.filteredPigRunOptions,
                        label: "Select Pig Run",
                        "display-value": 
                _ctx.selectedPigRun ? _ctx.truncateLabel(_ctx.selectedPigRun.label) : ''
              ,
                        onFilter: _ctx.filterPigRuns,
                        onClear: _ctx.onClearPigRun
                      }, null, 8, ["modelValue", "use-input", "options", "display-value", "onFilter", "onUpdate:modelValue", "onClear"]),
                      _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          class: "btn-brand",
                          icon: "file_download",
                          label: "Export CSV",
                          "no-caps": "",
                          disable: _ctx.selectedPigRun == '',
                          onClick: _ctx.onExportPigRun
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          class: "btn-brand",
                          icon: "fas fa-edit",
                          label: "Edit",
                          "no-caps": "",
                          disable: _ctx.selectedPigRun == '',
                          onClick: _ctx.onEditPigRun
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          class: "btn-brand",
                          icon: "fas fa-trash-alt",
                          label: "Delete",
                          "no-caps": "",
                          disable: _ctx.selectedPigRun == '',
                          onClick: _ctx.onDeletePigRun
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      (_ctx.selectedPigRunType === 'LT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              rounded: "",
                              class: "btn-brand",
                              icon: "fas fa-rocket",
                              label: "Launch Pig",
                              "no-caps": "",
                              disable: _ctx.selectedPigRun == '',
                              onClick: _ctx.onLaunchPigRun
                            }, null, 8, ["disable", "onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPigRunType === 'R')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              rounded: "",
                              class: "btn-brand",
                              icon: "fas fa-history",
                              label: "Reconstruct",
                              "no-caps": "",
                              disable: _ctx.selectedPigRun == '',
                              onClick: _ctx.onWizardReconstruct
                            }, null, 8, ["disable", "onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_q_separator, { inset: "" }),
              _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
              (_ctx.completedPigRuns.length > 0)
                ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                    key: 1,
                    modelValue: _ctx.completedRunSectionExpanded,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.completedRunSectionExpanded) = $event)),
                    dense: "",
                    "header-class": "text-overline text-grey-brand",
                    label: "Completed Run Reports"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedPigReport,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPigReport) = $event)),
                          _ctx.onPreviewCompletedPigRun
                        ],
                        dense: "",
                        color: "blue-brand",
                        outlined: "",
                        clearable: "",
                        "use-input": !_ctx.selectedPigReport,
                        "input-debounce": "300",
                        options: _ctx.filteredCompletedRunOptions,
                        label: "Completed Run",
                        "display-value": 
                _ctx.selectedPigReport ? _ctx.truncateLabel(_ctx.selectedPigReport.label) : ''
              ,
                        onFilter: _ctx.filterCompletedRuns,
                        onClear: _ctx.onClearCompletedPigRun
                      }, null, 8, ["modelValue", "use-input", "options", "display-value", "onFilter", "onUpdate:modelValue", "onClear"]),
                      (_ctx.selectedCompletedPigRunId)
                        ? (_openBlock(), _createBlock(_component_PigRunSummary, {
                            key: 0,
                            "pig-run-id": _ctx.selectedCompletedPigRunId,
                            "skip-plot": "",
                            class: "q-mt-sm"
                          }, null, 8, ["pig-run-id"]))
                        : _createCommentVNode("", true),
                      _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          "no-caps": "",
                          icon: "fas fa-trash-alt",
                          class: "btn-brand",
                          label: "Delete Run",
                          disable: _ctx.selectedPigReport == '',
                          onClick: _ctx.onDeleteReport
                        }, null, 8, ["disable", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          "no-caps": "",
                          icon: "edit",
                          class: "btn-brand",
                          label: "Edit Time",
                          disable: _ctx.selectedPigReport == '',
                          onClick: _ctx.onEditTime
                        }, null, 8, ["disable", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          "no-caps": "",
                          icon: "add",
                          class: "btn-brand",
                          label: "Add AGMs",
                          disable: _ctx.selectedPigReport == '',
                          onClick: _ctx.onAddAgmsDialog
                        }, null, 8, ["disable", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          loading: _ctx.isRCompRunSynching,
                          "no-caps": "",
                          icon: "refresh",
                          class: "btn-brand",
                          label: "Synch Run",
                          disable: _ctx.selectedPigReport == '',
                          onClick: _ctx.onSynchRun
                        }, null, 8, ["loading", "disable", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          "no-caps": "",
                          icon: "fas fa-broadcast-tower",
                          class: "btn-brand",
                          label: "Broadcast Command",
                          disable: _ctx.completedPigRunBroadcastCommandButtonDisable,
                          onClick: _ctx.completedPigRunBroadcastCommandButtonOnClick
                        }, null, 8, ["disable", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createVNode(_component_q_btn, {
                          flat: "",
                          rounded: "",
                          "no-caps": "",
                          icon: "assessment",
                          class: "btn-brand",
                          label: "View Report",
                          disable: _ctx.selectedPigReport == '',
                          onClick: _ctx.onOpenReportForCompletedRun
                        }, null, 8, ["disable", "onClick"]), [
                          [_directive_close_popup]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_dialog, {
                modelValue: _ctx.addAgmsDialog,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addAgmsDialog) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card, { style: {"width":"400px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_toolbar, null, {
                        default: _withCtx(() => [
                          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add AGMs", -1)),
                          _createVNode(_component_q_space),
                          _withDirectives(_createVNode(_component_q_btn, {
                            flat: "",
                            round: "",
                            dense: "",
                            icon: "close",
                            onClick: _ctx.onAgmListCancelled
                          }, null, 8, ["onClick"]), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_q_input, {
                              modelValue: _ctx.addAgmSearch,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addAgmSearch) = $event)),
                              dense: "",
                              outlined: "",
                              color: "blue-brand",
                              label: "Search",
                              clearable: "",
                              style: {"flex":"1"}
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "search" })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_q_input, {
                              modelValue: _ctx.addAgmRangeFrom,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addAgmRangeFrom) = $event)),
                              dense: "",
                              outlined: "",
                              type: "number",
                              label: "From",
                              style: {"max-width":"80px"},
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_input, {
                              modelValue: _ctx.addAgmRangeTo,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addAgmRangeTo) = $event)),
                              dense: "",
                              outlined: "",
                              type: "number",
                              label: "To",
                              style: {"max-width":"80px"},
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              "no-caps": "",
                              color: "blue-brand",
                              label: "Select Range",
                              disable: !_ctx.addAgmRangeFrom || !_ctx.addAgmRangeTo,
                              onClick: _ctx.onAddAgmSelectRange
                            }, null, 8, ["disable", "onClick"]),
                            _createVNode(_component_q_space),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              "no-caps": "",
                              color: "blue-brand",
                              label: _ctx.allAddAgmsSelected ? 'Deselect All' : 'Select All',
                              onClick: _ctx.onToggleSelectAllAddAgms
                            }, null, 8, ["label", "onClick"])
                          ]),
                          _createVNode(_component_q_list, {
                            ref: "addAgmList",
                            bordered: "",
                            separator: "",
                            class: "rounded-borders",
                            style: {"max-height":"350px","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAddAgmOptions, (agm) => {
                                return (_openBlock(), _createBlock(_component_q_item, {
                                  key: agm.value,
                                  tag: "label",
                                  dense: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_checkbox, {
                                          modelValue: _ctx.addAgmSelected,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addAgmSelected) = $event)),
                                          val: agm.value,
                                          color: "blue-brand"
                                        }, null, 8, ["modelValue", "val"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agm.label), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              (_ctx.filteredAddAgmOptions.length === 0)
                                ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { class: "text-grey-6 text-center" }, {
                                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                          _createTextVNode(" No AGMs available to add ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 512),
                          _createVNode(_component_q_separator, { class: "q-mt-md" }),
                          _createVNode(_component_q_card_actions, { align: "center" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_q_btn, {
                                class: "btn-brand",
                                label: "Cancel",
                                "no-caps": "",
                                onClick: _ctx.onAgmListCancelled
                              }, null, 8, ["onClick"]), [
                                [_directive_close_popup]
                              ]),
                              _withDirectives(_createVNode(_component_q_btn, {
                                class: "btn-brand",
                                label: "Save Selected",
                                "no-caps": "",
                                disable: _ctx.addAgmSelected.length === 0,
                                onClick: _ctx.onAgmListChanged
                              }, null, 8, ["disable", "onClick"]), [
                                [_directive_close_popup]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.wizardVisible]
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.EditTimeDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.EditTimeDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Edit Launch/Receive Time", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.ErrorMsg)
                  ? (_openBlock(), _createBlock(_component_q_form, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, {
                          class: "q-ml-sm",
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.ErrorMsgString), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.LaunchCompTimestamp,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.LaunchCompTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Launch Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.LaunchCompTimestamp,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.LaunchCompTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.LaunchCompTimestamp,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.LaunchCompTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_separator),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.ReceiveCompTimestamp,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ReceiveCompTimestamp) = $event)),
                          dense: "",
                          filled: "",
                          label: "Receive Time (UTC)"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "event",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      modelValue: _ctx.ReceiveCompTimestamp,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ReceiveCompTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      onInput: _ctx.hideDateProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "access_time",
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qTimeProxy",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_time, {
                                      modelValue: _ctx.ReceiveCompTimestamp,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ReceiveCompTimestamp) = $event)),
                                      mask: "YYYY-MM-DD HH:mm:ss",
                                      format24h: "",
                                      onInput: _ctx.hideTimeProxy
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode(_component_q_card_actions, { align: "center" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_q_btn, {
                          "no-caps": "",
                          class: "btn-brand",
                          label: "Cancel"
                        }, null, 512), [
                          [_directive_close_popup]
                        ]),
                        _createVNode(_component_q_btn, {
                          "no-caps": "",
                          class: "btn-brand",
                          label: "Add",
                          onClick: _ctx.onEditCompTime
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.launchPigDialog,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.launchPigDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"400px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Launch the Pig", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.launchPigToolName,
                      "onUpdate:modelValue": [
                        _cache[16] || (_cache[16] = ($event: any) => ((_ctx.launchPigToolName) = $event)),
                        _ctx.onReadyLaunch
                      ],
                      dense: "",
                      color: "blue-brand",
                      type: "text",
                      outlined: "",
                      label: "Tool Name",
                      maxlength: "100",
                      rules: [_ctx.toolNameRule],
                      "reactive-rules": "",
                      "hide-bottom-space": ""
                    }, null, 8, ["modelValue", "rules", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.launchPigToolType,
                      "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event: any) => ((_ctx.launchPigToolType) = $event)),
                        _ctx.onReadyLaunch
                      ],
                      dense: "",
                      color: "blue-brand",
                      outlined: "",
                      options: _ctx.launchPigToolTypeOptions,
                      label: "Select Tool Type",
                      "emit-value": "",
                      "map-options": ""
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.LaunchTimestamp,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                      dense: "",
                      outlined: "",
                      label: "Launch Time (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.LaunchTimestamp,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  onInput: _ctx.hideDateProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.LaunchTimestamp,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.LaunchTimestamp) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: "",
                                  "with-seconds": "",
                                  onInput: _ctx.hideTimeProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.directionIsBackward,
                      "onUpdate:modelValue": [
                        _cache[21] || (_cache[21] = ($event: any) => ((_ctx.directionIsBackward) = $event)),
                        _ctx.onRunBackwardsChanged
                      ],
                      dense: "",
                      color: "blue-brand",
                      label: "Run Backwards"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [0, 8]
                        }, {
                          default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                            _createTextVNode(" This is for bidirectional Pigruns where the launch and recieve locations can be swapped. ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      dense: "",
                      "no-caps": "",
                      color: "grey-7",
                      icon: 
                  _ctx.showAdvancedLaunchOptions ? 'expand_less' : 'expand_more'
                ,
                      label: 
                  _ctx.showAdvancedLaunchOptions
                    ? 'Hide Advanced'
                    : 'Advanced Options'
                ,
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showAdvancedLaunchOptions = !_ctx.showAdvancedLaunchOptions))
                    }, null, 8, ["icon", "label"])
                  ]),
                  (_ctx.showAdvancedLaunchOptions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.launchPigExpectedSpeed,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.launchPigExpectedSpeed) = $event)),
                            modelModifiers: { number: true },
                            dense: "",
                            color: "blue-brand",
                            type: "number",
                            outlined: "",
                            label: _ctx.expectedSpeedLabel,
                            hint: "Override the default speed",
                            clearable: "",
                            class: "col",
                            onClear: _cache[24] || (_cache[24] = ($event: any) => (_ctx.launchPigExpectedSpeed = null))
                          }, null, 8, ["modelValue", "label"]),
                          _createVNode(_component_q_select, {
                            modelValue: _ctx.launchPigSpeedUnit,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.launchPigSpeedUnit) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            options: [
                    { label: 'mph', value: 'mph' },
                    { label: 'km/h', value: 'km/h' },
                  ],
                            "emit-value": "",
                            "map-options": "",
                            style: {"width":"90px"}
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ErrorMsg)
                    ? (_openBlock(), _createBlock(_component_q_badge, {
                        key: 1,
                        class: "q-ml-sm q-mb-sm",
                        color: "red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ErrorMsgString), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "center" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Cancel"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "fas fa-rocket",
                  class: "btn-brand",
                  disabled: _ctx.disableLaunch,
                  label: "Launch",
                  onClick: _ctx.onAddLaunchTime
                }, null, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_BackwardsConfirmDialog, {
      modelValue: _ctx.showBackwardsConfirm,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showBackwardsConfirm) = $event)),
      "pig-run-id": _ctx.selectedPigRun ? _ctx.selectedPigRun.value : 0,
      markers: _ctx.previewSortedMarkers,
      onConfirmed: _ctx.onBackwardsConfirmed,
      onCancelled: _ctx.onBackwardsCancelled
    }, null, 8, ["modelValue", "pig-run-id", "markers", "onConfirmed", "onCancelled"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.displayCompletedPigRunBroadcastCommandDialog,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.displayCompletedPigRunBroadcastCommandDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode("Completed Pig Run Broadcast Commands", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_markup_table, null, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[59] || (_cache[59] = _createElementVNode("th", { class: "text-left" }, [
                          _createElementVNode("span", { class: "text-bold" }, "Command")
                        ], -1)),
                        _createElementVNode("th", _hoisted_27, [
                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-bold q-pr-sm" }, "Now", -1)),
                          _createVNode(_component_q_icon, { name: "fas fa-info-circle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, null, {
                                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                  _createTextVNode("Commands to be sent to AGMs now.", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[60] || (_cache[60] = _createElementVNode("td", { class: "text-left" }, "Download between launch and receive", -1)),
                        _createElementVNode("td", _hoisted_28, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: 
                      _ctx.completedPigRunBroadcastCommandDownloadBetweenLaunchAndReceive
                    ,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((
                      _ctx.completedPigRunBroadcastCommandDownloadBetweenLaunchAndReceive
                    ) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  label: "Broadcast Commands Now",
                  "no-caps": "",
                  onClick: _ctx.completedPigRunBroadcastCommandBroadcastNowOnClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.reconstructDialog,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.reconstructDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"400px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Reconstruct Pig Run", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "q-mb-sm text-grey-8" }, " Enter the launch and receive dates for the selected pig run. The system will find matching passage detections and associate them with the pipeline markers. ", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.reconstructLaunchDate,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.reconstructLaunchDate) = $event)),
                      dense: "",
                      filled: "",
                      label: "Launch Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "reconstructLaunchDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.reconstructLaunchDate,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.reconstructLaunchDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  onInput: _ctx.hideReconstructLaunchDateProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "reconstructLaunchTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.reconstructLaunchDate,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.reconstructLaunchDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: "",
                                  onInput: _ctx.hideReconstructLaunchTimeProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.reconstructReceiveDate,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.reconstructReceiveDate) = $event)),
                      dense: "",
                      filled: "",
                      label: "Receive Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "reconstructReceiveDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.reconstructReceiveDate,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.reconstructReceiveDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  onInput: _ctx.hideReconstructReceiveDateProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "reconstructReceiveTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.reconstructReceiveDate,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.reconstructReceiveDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: "",
                                  onInput: _ctx.hideReconstructReceiveTimeProxy
                                }, null, 8, ["modelValue", "onInput"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "center" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Cancel"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Reconstruct",
                  loading: _ctx.isReconstructing,
                  disable: !_ctx.reconstructLaunchDate || !_ctx.reconstructReceiveDate,
                  onClick: _ctx.onReconstructConfirm
                }, null, 8, ["loading", "disable", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_PigRunWizard, {
      ref: "pigRunWizard",
      onSaved: _ctx.onWizardSaved,
      onVisibilityChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.wizardVisible = $event))
    }, null, 8, ["onSaved"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.launchMarkerPassagePromptDialog,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.launchMarkerPassagePromptDialog) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"450px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-blue-brand text-bold" }, "Add Launch Passage?", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _cache[64] || (_cache[64] = _createElementVNode("p", null, " The launch site has a marker in the TRACK state. The pig icon will not move until a passage at this marker is verified. Do you want to add a manual passage at the launch marker? ", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.launchMarkerPassageTimestamp,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.launchMarkerPassageTimestamp) = $event)),
                    dense: "",
                    outlined: "",
                    label: "Passage Time (UTC)"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "event",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "launchPassageDateProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_date, {
                                modelValue: _ctx.launchMarkerPassageTimestamp,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.launchMarkerPassageTimestamp) = $event)),
                                mask: "YYYY-MM-DD HH:mm:ss",
                                onInput: _ctx.hideLaunchPassageDateProxy
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "access_time",
                        class: "cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            ref: "launchPassageTimeProxy",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_time, {
                                modelValue: _ctx.launchMarkerPassageTimestamp,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.launchMarkerPassageTimestamp) = $event)),
                                mask: "YYYY-MM-DD HH:mm:ss",
                                format24h: "",
                                "with-seconds": "",
                                onInput: _ctx.hideLaunchPassageTimeProxy
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_ctx.launchMarkerPassageErrorMsg)
                  ? (_openBlock(), _createBlock(_component_q_badge, {
                      key: 0,
                      class: "q-ml-sm q-mb-sm",
                      color: "red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.launchMarkerPassageErrorMsgString), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "No"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  class: "btn-brand",
                  label: "Yes",
                  loading: _ctx.isAddingLaunchPassage,
                  onClick: _ctx.onAddLaunchMarkerPassage
                }, null, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showInstructions,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.showInstructions) = $event)),
      title: "Getting Started",
      icon: "route",
      message: "Pig runs are built on top of pipelines. Before creating a pig run, set up your pipeline in the Pipeline Manager.",
      "action-label": "Open Pipeline Manager",
      "action-icon": "settings",
      onAction: _ctx.onOpenPipelineSectionManager
    }, null, 8, ["modelValue", "onAction"]),
    _createVNode(_component_PipelineSectionManager, {
      modelValue: _ctx.managePipelineSectionDialog,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.managePipelineSectionDialog) = $event))
    }, null, 8, ["modelValue"])
  ], 512)), [
    [_vShow, _ctx.showPigRunManager]
  ])
}